













import Vue from 'vue'
import SvgIcon from 'vue-svgicon'
import { IconPropItem } from '@/components/ui/UiIcons/iconsPropsMixin'
import { getCssProp } from '@/utils/plugins/cssManage'
import { dynamicImport } from '@/utils/helpers/helpFunctions'

Vue.use(SvgIcon, {
  tagName: 'svgicon'
})

export default Vue.extend({
  name: 'UiIconSimple',
  props: {
    icon: {
      type: Object as () => IconPropItem,
      required: false
    },
    iconName: String,
    fill: String,
    stroke: String,
    width: String,
    height: String,
    id: String,
    originalColor: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {}
  },
  created () {
    dynamicImport(() => import('@/assets/icons'))
  },
  methods: {
    getFillColor (): string {
      if (this.originalColor || (this.icon && this.icon.originalColor)) return ''
      const getColor = (fillOrStroke: string): string => {
        if (fillOrStroke.includes('--')) {
          return getCssProp(fillOrStroke)
        }
        return fillOrStroke
      }
      if (this.icon && this.icon.fill) {
        return getColor(this.icon.fill)
      }
      if (this.icon && this.icon.stroke) {
        return getColor(this.icon.stroke)
      }
      return this.fill || '#fff' // TODO: get icon var from CSS
    }
  }
})
